<template>
    <div class="NoticeComponents">
        <van-notice-bar :background="background" :delay="delay" :color="color" :left-icon="leftIcon"
            :scrollable="scrollable" :mode="mode" :text="text" :style="{ borderRadius: round }" @click="getpath">
            <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false" v-if="list.length > 0">
                <van-swipe-item v-for="(item, index) in list" :key="index">{{
                    item.name
                }}</van-swipe-item>
            </van-swipe>
        </van-notice-bar>
    </div>
</template>

<script>
export default {
    name: "NoticeComponents",
    props: {
        round: {
            type: String,
            default: "10px",
        },
        // 通知栏模式，可选值为 closeable link
        mode: {
            type: String,
            default: "link",
        },
        // 是否开启滚动播放，内容长度溢出时默认开启
        scrollable: {
            type: Boolean,
            default: false,
        },
        // 通知文本内容
        text: {
            type: String,
            default: "这是一条公告",
        },
        //滚动条背景
        background: {
            type: String,
            default: "var(--text-accent)",
        },
        // 通知文本颜色
        color: {
            type: String,
            default: "var(--text-primary)",
        },
        // 左侧图标
        leftIcon: {
            type: String,
            default: require("@/assets/image/laba.png"),
        },
        //动画延迟时间 (s)
        delay: {
            type: Number,
            default: 1,
        },
        // 通知列表数据
        list: {
            type: Array,
            default: () => [
                // {
                //   name: '11'
                // }
            ],
        },
    },
    methods: {
        getpath() {
            this.$emit("Path");
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>